import React from 'react';
import { Callout, CalloutInputs } from '../Callout/Callout';
import './PolicyOverviewBlock.scss';

export const PolicyOverviewBlock = ({ node }) => {
    const ctaFirst: CalloutInputs = {
        policyOverviewBlock: true,
        bgColor: `gray`,
        textContent: node.field_overviewblock5text?.value,
        title: node.field_overviewblock5title,
        cta: [
            {
                uri: node.field_overviewblock5link?.uri,
                title: node.field_overviewblock5link?.title,
            },
        ],
        imagePosition: `left`,
        calloutImage: {
            alt: node.field_overviewblock5image?.alt,
            gatsbyImage:
                node.relationships?.field_overviewblock5image?.localFile,
        },
    };

    const ctaSecond: CalloutInputs = {
        policyOverviewBlock: true,
        bgColor: `gray`,
        textContent: node.field_overviewblock5text1?.value,
        title: node.field_overviewblock5title1,
        cta: [
            {
                uri: node.field_overviewblock5link1?.uri,
                title: node.field_overviewblock5link1?.title,
            },
        ],
        imagePosition: `right`,
        calloutImage: {
            alt: node.field_overviewblock5image1?.alt,
            gatsbyImage:
                node.relationships?.field_overviewblock5image1?.localFile,
        },
    };

    return (
        <>
            <Callout inputs={ctaFirst} />
            {ctaSecond.title && (
                <>
                    <div className="ns"></div>
                    <Callout inputs={ctaSecond} />
                </>
            )}
        </>
    );
};
